import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { useAuthStore } from '@/features/auth/model/auth-store';
import { KairoLogo } from '@/shared/ui/KairoLogo';

/**
 * Гард защищённых маршрутов.
 *
 * Пока сессия восстанавливается из хранилища, показывается заставка, а не
 * экран входа: иначе при каждом запуске приложения мелькала бы форма
 * авторизации, хотя пользователь уже вошёл.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const status = useAuthStore((state) => state.status);

  if (status === 'idle' || status === 'loading') {
    return <SplashScreen />;
  }

  if (status === 'anonymous') {
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
}

function SplashScreen() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4">
      <KairoLogo size={64} className="animate-[var(--animate-pop-in)]" />
      <p className="text-[13px] text-subtle">Загружаем ваше расписание…</p>
    </div>
  );
}
